module.exports = __webpack_public_path__ + "img/gear-fingerboard.441e3a54.svg";